// Avatar encoding helpers. The interactive cropper (AvatarCropper) decides the
// framing; these helpers just load the source image and encode a finished
// square canvas into the bytes (for the gRPC upload) plus a data URL (for an
// instant local preview).
export const loadImageFromUrl = (url) => new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Could not read that image.'));
    img.src = url;
});
export const encodeSquareCanvas = async (canvas) => {
    const contentType = 'image/jpeg';
    const dataUrl = canvas.toDataURL(contentType, 0.9);
    const blob = await new Promise((resolve, reject) => canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('Could not encode that image.'))), contentType, 0.9));
    const bytes = new Uint8Array(await blob.arrayBuffer());
    return { bytes, contentType, dataUrl };
};
